
import { URLS } from '../constants'
import {
    SET_BATCH_FILES_TABLE_PAGINATION,
    GET_ALL_BATCH_FILES_BEGIN, GET_ALL_BATCH_FILES_SUCCESS, GET_ALL_BATCH_FILES_FAILURE,
    UPLOAD_BATCH_FILE_BEGIN, UPLOAD_BATCH_FILE_SUCCESS, UPLOAD_BATCH_FILE_FAILURE,
    DOWNLOAD_BATCH_FILE_BEGIN, DOWNLOAD_BATCH_FILE_SUCCESS, DOWNLOAD_BATCH_FILE_FAILURE
} from '../constants/ActionTypes'

import { dispatchFetchGet, dispatchFetchGetFile, dispatchFetchPostFormData, setUrlSearchParams } from './ActionUtil'

// All Batch Files Table
export const acSetBatchFilesTablePagination = data => ({ type: SET_BATCH_FILES_TABLE_PAGINATION, payload: data })

// Get All Batch Files
const acGetAllBatchFilesBegin = () => ({ type: GET_ALL_BATCH_FILES_BEGIN })
const acGetAllBatchFilesSuccess = data => ({ type: GET_ALL_BATCH_FILES_SUCCESS, payload: data })
const acGetAllBatchFilesFailure = err => ({ type: GET_ALL_BATCH_FILES_FAILURE, payload: err })

/**
 * @description Retrieves all batch files from the server.
 *
 * @author Maria Eduarda Franke
 */
export const acGetAllBatchFiles = payload => {

    let url = URLS.BATCH_FILE

    if (payload) {
        url = setUrlSearchParams(url, payload)
    }

    return dispatchFetchGet(
        url,
        acGetAllBatchFilesBegin,
        acGetAllBatchFilesSuccess,
        acGetAllBatchFilesFailure
    )
}

// Get/Download Batch File
const acDownloadBatchFileBegin = () => ({ type: DOWNLOAD_BATCH_FILE_BEGIN })
const acDownloadBatchFileSuccess = () => ({ type: DOWNLOAD_BATCH_FILE_SUCCESS, payload: { message: "Download efetuado com sucesso!" } })
const acDownloadBatchFileFailure = err => ({ type: DOWNLOAD_BATCH_FILE_FAILURE, payload: err })

/**
 * @description Dispatches a GET request to download a batch file.
 *
 * @author Maria Eduarda Franke
 */
export const acDownloadBatchFile = (batchFileId, file = 'output') => {
    return dispatchFetchGetFile(
        `${URLS.BATCH_FILE}/${batchFileId}/${file}`,
        acDownloadBatchFileBegin,
        acDownloadBatchFileSuccess,
        acDownloadBatchFileFailure
    )
}

// Post/Upload Batch File
const acUploadBatchFileBegin = () => ({ type: UPLOAD_BATCH_FILE_BEGIN })
const acUploadBatchFileSuccess = data => ({ type: UPLOAD_BATCH_FILE_SUCCESS, payload: data })
const acUploadBatchFileFailure = err => ({ type: UPLOAD_BATCH_FILE_FAILURE, payload: err })

/**
 * @description Dispatches a POST request to upload a batch file.
 *
 * @author Maria Eduarda Franke
 */
export const acUploadBatchFile = batchFile => {
    return dispatchFetchPostFormData(
        URLS.BATCH_FILE,
        batchFile,
        acUploadBatchFileBegin,
        acUploadBatchFileSuccess,
        acUploadBatchFileFailure
    )
}